"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfig = exports.getDefaultConfig = void 0;

var _merge2 = _interopRequireDefault(require("lodash/merge"));

var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));

var _content = require("./content");

var _types = require("../types");

var getDefaultConfig = function getDefaultConfig(countryCode) {
  return {
    countryCode: countryCode || _types.Region.ALL,
    userToken: '',
    guid: '',
    onEvent: function onEvent() {
      return null;
    },
    maxNumberStatementDays: 90,
    showLoginAgainLink: true,
    initialBackButton: null,
    errorFallbackButton: null,
    formButtonsLayout: 'stacked',
    theme: {
      bgColor: 'transparent',
      inputColor: undefined,
      highlightColor: 'highlight.blue.t100',
      headingColor: 'highlight.blue.t100',
      headingSize: 'heading5'
    },
    content: (0, _content.getDefaultContent)(countryCode)
  };
};

exports.getDefaultConfig = getDefaultConfig;

var getConfig = function getConfig(config) {
  if (!config) {
    return getDefaultConfig();
  }

  var countryCode = config.countryCode,
      guid = config.guid,
      userToken = config.userToken,
      onEvent = config.onEvent,
      maxNumberStatementDays = config.maxNumberStatementDays,
      showLoginAgainLink = config.showLoginAgainLink,
      initialBackButton = config.initialBackButton,
      additionalErrorMessage = config.additionalErrorMessage,
      errorFallbackButton = config.errorFallbackButton,
      formButtonsLayout = config.formButtonsLayout,
      theme = config.theme,
      content = config.content;
  var customConfig = {
    countryCode: countryCode,
    guid: guid,
    userToken: userToken,
    onEvent: onEvent,
    maxNumberStatementDays: maxNumberStatementDays,
    showLoginAgainLink: showLoginAgainLink,
    initialBackButton: initialBackButton,
    additionalErrorMessage: additionalErrorMessage,
    errorFallbackButton: errorFallbackButton,
    formButtonsLayout: formButtonsLayout,
    theme: theme,
    content: content
  };
  return (0, _cloneDeep2.default)((0, _merge2.default)({}, getDefaultConfig(countryCode), customConfig));
};

exports.getConfig = getConfig;